// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"b6edf2de","640":"d3fc3aa1","690":"dac26154","776":"0b9c638d"}[chunkId] + ".chunk.css";
};